export default __webpack_public_path__ + "static/media/hammer.f416036f.png";